const $ = require('jquery');

import { MenuType } from "../enum/MenuType";
import { View } from "../../umadash.js/view/View";
import { Command } from "../../umadash.js/command/Command";
import { JqueryUtil } from "../../umadash.js/util/JqueryUtil";
import { Easing } from "../../umadash.js/tween/Easing";     
import { SmoothScroll } from "../../umadash.js/util/SmoothScroll";
import { DeviceUtil } from "../util/DeviceUtil";
import { WindowWatcher } from "../../umadash.js/util/WindowWatcher";

export class GlobalHeader {

    private $elm: JQuery;
    private $inner: JQuery;
    private $nav: JQuery;
    private $menuItem: JQuery;
    private $menuItemGame: JQuery;
    private $menuItemGameGroup: JQuery;
    private $navigationGames: JQuery;
    private $menuIcon: JQuery;
    private $currentMenuItem: JQuery;

    private openCommand: Command;
    private closeCommand: Command;

    private showGamesCommand: Command;
    private hideGamesCommand: Command;

    private static instance: GlobalHeader;
    public static getInstance(): GlobalHeader {
        if (!this.instance) {
            this.instance = new GlobalHeader();
        }
        return this.instance;
    }

    private constructor() {

        this.$elm = $('#js-globalHeader');
        this.$inner = this.$elm.find('.globalHeaderNavigation__inner');
        this.$nav = this.$elm.find('.globalHeader__nav');
        this.$menuIcon = this.$elm.find('.globalHeader__menu');
        this.$menuItem = this.$elm.find('.menuItem');

        this.$menuItemGameGroup = this.$elm.find('#js-menuItemGroupGame');
        this.$menuItemGame = this.$elm.find('#js-menuItemGame');
        this.$navigationGames = this.$elm.find('#js-navigationGames');

        this.init();
    }

    public setCurrentMenu(type: MenuType): void {
        const $nextCurrentItem: JQuery = this.$menuItem.eq(type);
        if ($nextCurrentItem === this.$currentMenuItem) return;

        if (this.$currentMenuItem) {
            this.$currentMenuItem.removeClass('menuItem--current');
        }
        $nextCurrentItem.addClass('menuItem--current');
        this.$currentMenuItem = $nextCurrentItem;
    }

    private scrollTop: number;
    private fix(): void {
        const scrollTop: number = WindowWatcher.getScrollTop();
        $('#js-wrapper').css({
            position: 'fixed',
            top: -(scrollTop)
        });
        this.scrollTop = scrollTop;
    }

    private release(): void {
        $('#js-wrapper').css({
            position: 'relative',
            top: 'auto'
        });
        window.scrollTo(0, this.scrollTop);
    }

    private addEventListeners(): void {
        if (DeviceUtil.isSp()) {
            SmoothScroll.getDispatcher().addEventListener(SmoothScroll.Move, () => {
                if (DeviceUtil.isSp()) {
                    this.close();
                }
            });

            this.$inner.on('click', (e) => {
                this.close();
            });

            this.$menuItemGame.on('click', () => {
                this.$navigationGames.slideToggle();
                return false;
            });

            this.$menuIcon.on('click', () => {
                console.log('click');
                if (this.$menuIcon.hasClass('menuIcon--cross')) {

                    this.close();
                }
                else {
                    this.open();
                }
            });
        }
        else {
            this.$menuItemGameGroup.on('mouseenter', () => {
                this.cancelAppearGamesCommand();
                this.showGamesCommand = this.getShowGamesCommand(true);
            });
    
            this.$menuItemGameGroup.on('mouseleave', () => {
                this.cancelAppearGamesCommand();
                this.hideGamesCommand = this.getHideGamesCommand(true);
            });
        }
    }

    private init(): void {
        this.addEventListeners();
    }

    private getShowGamesCommand(execute: boolean): Command {
        return JqueryUtil.fadeIn(this.$navigationGames, 320, Easing.easeOutQuart, 'flex', true, execute);
    }

    private getHideGamesCommand(execute: boolean): Command {
        return JqueryUtil.fadeOut(this.$navigationGames, 200, Easing.easeOutQuart, 'none', true, execute);
    }

    public open(): void {
        this.cancelAppearCommand();

        this.$menuIcon.addClass('menuIcon--cross');
        this.openCommand = this.getOpenCommand(true);
        this.fix();
    }

    private close(): void {
        this.cancelAppearCommand();

        this.$menuIcon.removeClass('menuIcon--cross');
        this.closeCommand = this.getCloseCommand(true);
        this.release();
    }

    private cancelAppearCommand(): void {
        if (this.openCommand) {
            this.openCommand.interrupt();
            this.openCommand = null;
        }

        if (this.closeCommand) {
            this.closeCommand.interrupt();
            this.closeCommand = null;
        }
    }

    private cancelAppearGamesCommand(): void {
        if (this.showGamesCommand) {
            this.showGamesCommand.interrupt();
            this.showGamesCommand = null;
        }
        if (this.hideGamesCommand) {
            this.hideGamesCommand.interrupt();
            this.hideGamesCommand = null;
        }
    }

    private getOpenCommand(execute: boolean): Command {
        return JqueryUtil.fadeIn(this.$nav, 300, Easing.easeOutQuart, 'block', true, execute);
    }

    private getCloseCommand(execute: boolean): Command {
        return JqueryUtil.fadeOut(this.$nav, 300, Easing.linear, 'none', true, execute);
    }
}